'use strict';

var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates a Tab
 *
 * @class
 */

class FormSelectBox extends Core {

    _defaults() {
        return {
            target: '.js-formselectbox',
            fields: {
                'datamember': null,
                'options': [],
                'read_only': false
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
                <div class="editor__form__selectbox editor__form__selectbox--single">
                        <select class="editor__form__selectbox__select editor__form__selectbox__select--single js-form__select" <% if(read_only){ %>disabled="disabled" readonly="readonly"<% } %>>
                                <% _.each(options, function(option){ %>
                                        <option value='<%- option["value"] %>' name='<%- option["name"] %>'><%- option["name"] %></option>
                                <% }); %>
                        </select>
                </div>
        `;

        super.render();

        /**
         * Text input
         *
         * @fires Formselectbox#_valuechanged
         */

         this.$el.on('input', this._valuechanged);
    }

    _valuechanged(e){
    	$(e.currentTarget).trigger('Cioui:Form:value', $(e.currentTarget).find('option:selected').attr("value"));
    	$(e.currentTarget).trigger('Cioui:Form:label', $(e.currentTarget).find('option:selected').attr("name"));
    }

    /**
     * setValue
     *
     * @param {string} value - the value that you want to set
     */

    setValue(value){
	    var selectBox = $('.js-form__select', this.$el);
        selectBox.val(value);
    }
}
module.exports = FormSelectBox;
